"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledOption = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var themes_1 = require("../../../../themes");
var mixins_1 = require("../../../../themes/mixins");
var utilsOolib_1 = require("../../../../utilsOolib");
var globalVariables_1 = require("../../../../globalStyles/globalVariables");
exports.StyledOption = styled_components_1.default.li(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    padding: ", ";\n    ", "\n    ", ";\n\n    background-color: ", ";\n\n    ", "\n\n    &:first-of-type {\n      margin-top: 1rem;\n    }\n\n    &:last-of-type {\n      margin-bottom: 1rem;\n    }\n\n    .OKE-Dropdown__optionDesc {\n      @include kp-clamp-text(2);\n      white-space: normal;\n    }\n\n    .OKE-Dropdown__optionImg {\n      flex: 0 0 auto;\n    }\n\n    .OKE-Dropdown__checkboxClickArea {\n      position: absolute;\n      width: 2rem;\n      height: 2rem;\n    }\n    .OKE-Dropdown__checkboxClickArea-box {\n      margin-right: 1rem;\n      flex-shrink: 0;\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    padding: ", ";\n    ", "\n    ", ";\n\n    background-color: ", ";\n\n    ", "\n\n    &:first-of-type {\n      margin-top: 1rem;\n    }\n\n    &:last-of-type {\n      margin-bottom: 1rem;\n    }\n\n    .OKE-Dropdown__optionDesc {\n      @include kp-clamp-text(2);\n      white-space: normal;\n    }\n\n    .OKE-Dropdown__optionImg {\n      flex: 0 0 auto;\n    }\n\n    .OKE-Dropdown__checkboxClickArea {\n      position: absolute;\n      width: 2rem;\n      height: 2rem;\n    }\n    .OKE-Dropdown__checkboxClickArea-box {\n      margin-right: 1rem;\n      flex-shrink: 0;\n    }\n"])), function (_a) {
    var S = _a.S;
    return S ? '0.5rem 2rem' : ' 1rem 2rem';
}, function (_a) {
    var S = _a.S;
    return !S
        ? (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n       \n        min-height: 4rem;\n      "], ["\n       \n        min-height: 4rem;\n      "]))) : (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      /* height: 3rem; */\n      "], ["\n      /* height: 3rem; */\n      "])));
}, (0, mixins_1.transition)('background-color'), function (_a) {
    var isFocussed = _a.isFocussed, isSelected = _a.isSelected, theme = _a.theme, invert = _a.invert;
    return isSelected
        ? (invert ? themes_1.colors.greyColor70 : (0, utilsOolib_1.getPrimaryColor10)(theme === null || theme === void 0 ? void 0 : theme.colors))
        : isFocussed
            ? (invert ? themes_1.colors.greyColor80 : themes_1.colors.greyColor5)
            : (invert ? themes_1.colors.greyColor90 : themes_1.colors.white);
}, globalVariables_1.globalHoverOnWhiteBG);
var templateObject_1, templateObject_2, templateObject_3;
